import { Project } from '../types/entities'

export const mockProjects: Project[] = [
  {
    id: 'p1',
    name: 'RTGuard Portal',
    description: 'Portal web de monitoramento de câmeras e eventos ANPR/AHCR em tempo real.',
    clientId: 'c1',
    repositoryUrl: 'https://github.com/bsctecnologia/rtguard-portal',
    hosting: 'Azure',
    hostingUrl: 'https://rtguard.azurewebsites.net',
    techStack: ['React', 'TypeScript', 'PrimeReact'],
    status: 'active',
    createdAt: '2023-03-20',
  },
  {
    id: 'p2',
    name: 'RTGuard API',
    description: 'API REST para gestão de câmeras, eventos e alarmes do sistema RTGuard.',
    clientId: 'c1',
    repositoryUrl: 'https://github.com/bsctecnologia/rtguard-api',
    hosting: 'Azure',
    hostingUrl: 'https://rtguard-api.azurewebsites.net',
    techStack: ['Node.js', 'TypeScript', 'PostgreSQL'],
    status: 'active',
    createdAt: '2023-03-20',
  },
  {
    id: 'p3',
    name: 'Alfa PDV',
    description: 'Sistema de ponto de venda para rede de supermercados com integração fiscal.',
    clientId: 'c2',
    repositoryUrl: 'https://github.com/bsctecnologia/alfa-pdv',
    hosting: 'VPS',
    hostingUrl: 'https://pdv.supermercadosalfa.com.br',
    techStack: ['React', 'Node.js', 'PostgreSQL', 'Docker'],
    status: 'maintenance',
    createdAt: '2023-08-10',
  },
  {
    id: 'p4',
    name: 'VidaSaúde Agendamento',
    description: 'Plataforma de agendamento online de consultas médicas com notificações por WhatsApp.',
    clientId: 'c3',
    repositoryUrl: 'https://github.com/bsctecnologia/vidasaude-agenda',
    hosting: 'AWS',
    hostingUrl: 'https://agenda.vidasaude.com.br',
    techStack: ['Next.js', 'TypeScript', 'PostgreSQL', 'Redis'],
    status: 'active',
    createdAt: '2024-02-01',
  },
  {
    id: 'p5',
    name: 'Alvorada Obras',
    description: 'App mobile para controle de obras, cronograma e equipes em campo.',
    clientId: 'c4',
    repositoryUrl: 'https://github.com/bsctecnologia/alvorada-obras',
    hosting: 'Azure',
    techStack: ['React Native', 'Node.js', 'MongoDB'],
    status: 'development',
    createdAt: '2024-05-01',
  },
  {
    id: 'p6',
    name: 'FastMove Rastreamento',
    description: 'Dashboard de rastreamento de frotas em tempo real com mapa interativo.',
    clientId: 'c5',
    repositoryUrl: 'https://github.com/bsctecnologia/fastmove-track',
    hosting: 'AWS',
    hostingUrl: 'https://track.fastmove.com.br',
    techStack: ['React', 'Node.js', 'MongoDB', 'Docker'],
    status: 'active',
    createdAt: '2024-09-15',
  },
]
